<template>
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.33398 1.99967C3.33398 1.63148 3.63245 1.33301 4.00065 1.33301H12.0007C12.3689 1.33301 12.6673 1.63148 12.6673 1.99967V14.6663L10.334 12.9997L8.00065 14.6663L5.66732 12.9997L3.33398 14.6663V1.99967Z" stroke="#353B55" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6 7.33301H10" stroke="#353B55" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6 10H10" stroke="#353B55" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6 4.66699H10" stroke="#353B55" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

</template>